import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import * as colaApi from '@/modules/bd-unificada/api/colaApi'
import type { ColaFilters } from '@/modules/bd-unificada/types/cola'

export const colaKeys = {
  all: ['bd-unificada', 'cola'] as const,
  list: (filters?: ColaFilters) => [...colaKeys.all, 'list', { filters }] as const,
}

export function useCola(filters?: ColaFilters) {
  return useQuery({
    queryKey: colaKeys.list(filters),
    queryFn: () => colaApi.getCola(filters),
  })
}

export function useAprobarItem() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => colaApi.aprobarItem(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: colaKeys.all })
      toast.success('Item aprobado')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al aprobar el item')
    },
  })
}

export function useRechazarItem() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => colaApi.rechazarItem(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: colaKeys.all })
      toast.success('Item rechazado')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al rechazar el item')
    },
  })
}
